import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { UserTokenService } from '../services/user-service/user-token.service';
import { FCurrency } from '../models/resources/resources.model';

@Pipe({
  name: 'appCurrency',
  pure: true,
  standalone: false,
})
export class AppCurrencyPipe implements PipeTransform {
  constructor(
    private currencyPipe: CurrencyPipe,
    private userTokenService: UserTokenService,
  ) {
  }

  transform(
    value: number | string | null | undefined,
    currencyCode?: string | null,
    display: 'code' | 'symbol' | 'symbol-narrow' | string = 'symbol-narrow',
    digitsInfo: string = '1.2-2',
    localeOverride?: string,
  ): string {
    if ( value === null || value === undefined || value === '' ) {
      return '';
    }

    let displayCurrency =
      (currencyCode || CurrencyHelper.DEFAULT_CURRENCY).toUpperCase();

    if ( displayCurrency === 'EURO' ) {
      displayCurrency = CurrencyHelper.DEFAULT_CURRENCY;
    }

    let userCurrency = (this.userTokenService.getCurrency() || currencyCode || CurrencyHelper.DEFAULT_CURRENCY).toUpperCase();

    if ( userCurrency === 'EURO' ) {
      userCurrency = CurrencyHelper.DEFAULT_CURRENCY;
    }

    let locale = localeOverride;
    if ( !locale ) {
      switch ( userCurrency ) {
        case 'GBP':
          // Requirement: comma -> point, point -> comma
          // This is standard UK format: 1,234.56
          locale = 'en-GB';
          break;

        case 'CHF':
        case CurrencyHelper.DEFAULT_CURRENCY:
        default:
          // Your current behavior (e.g. de-DE)
          // 1.234,56
          locale = 'de-DE';
          break;
      }
    }

    return (
      this.currencyPipe.transform(
        value,
        displayCurrency,
        display,
        digitsInfo,
        locale,
      ) ?? ''
    );
  }
}

export class CurrencyHelper {

  static readonly DEFAULT_CURRENCY = 'EUR';
  static readonly DEFAULT_CURRENCY_ID = 1;
  static readonly FINSTRAL_CURRENCIES: FCurrency[] = [
    {
      Id: this.DEFAULT_CURRENCY_ID,
      Description: this.DEFAULT_CURRENCY
    },
    { Id: 2, Description: 'CHF' },
    { Id: 3, Description: 'GBP' },
  ];

  static getCurrencyId( code: string ): number {
    return this.FINSTRAL_CURRENCIES.find(c => c.Description === code)?.Id ?? this.DEFAULT_CURRENCY_ID;
  }
}

